import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { States } from '../model/states';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment.prod';

@Injectable({
  providedIn: 'root'
})

export class StateService {
  apiUrl = environment.apiURL;
  constructor(private http: HttpClient) { }

  get() {

    // return this.statedatalist;
  }
  getStates(): Observable<States> {
    return this.http.get(this.apiUrl + 'states');
  }
}
